var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBglogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{isolation:isolate;}.cls-3{fill:#512d6d;}.cls-4{fill:#ff6900;}.cls-5{clip-path:url(#clippath);}.cls-6{fill:none;}.cls-7{mix-blend-mode:multiply;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1865.79.34H56.14C25.66.34.96,22.71.96,50.31v979.38c0,27.6,24.7,49.97,55.17,49.97h1809.66c30.47,0,55.17-22.37,55.17-49.97V50.31c0-27.6-24.7-49.97-55.17-49.97Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1864.83.68H55.17C24.7.68,0,23.06,0,50.65v979.38c0,27.6,24.7,49.97,55.17,49.97h1809.66c30.47,0,55.17-22.37,55.17-49.97V50.65c0-27.6-24.7-49.97-55.17-49.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m589.39,0h275.64c-20.11,56.71-74.22,97.31-137.82,97.31S609.49,56.71,589.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1855.06,239.36h-402.36c29.35-82.77,108.34-142.05,201.18-142.05,92.84,0,171.83,59.27,201.18,142.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m529.44,311.62c501.36,46.41,343.4-73.27,696.37-114.43,444.74-51.87,470.86,14.16,786.15-56.25v934.37c0,42.83-119.75,77.56-267.49,77.56H167.92c-147.73,0-267.49-34.73-267.49-77.56V381.74s175.23-112.13,629.02-70.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m658.17,1080H125.2c38.88-84.68,143.51-145.31,266.49-145.31s227.61,60.64,266.49,145.31Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBglogin);
export default __webpack_public_path__ + "static/media/bglogin.259e37c71839478d46f93a639755975a.svg";
export { ForwardRef as ReactComponent };